import FullDayCalendarBatchList from "./FullDayCalendarBatchList";
import FullDayCalendarBatchEdit from "./FullDayCalendarBatchEdit";
import FullDayCalendarBatchCreate from "./FullDayCalendarBatchCreate";

export default {
    list: FullDayCalendarBatchList,
    create: FullDayCalendarBatchCreate,
    edit: FullDayCalendarBatchEdit
};
